import { Routes } from '@angular/router';
import { authGuard, loginGuard } from '@onrsr/ui/auth';
import { permissionGuard, requires } from './core/auth/permission.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    {
        path: 'dashboard',
        loadComponent: () =>
            import('./features/dashboard/dashboard').then((m) => m.Dashboard),
        canActivate: [authGuard],
    },
    {
        path: 'occurrences/awaitingtriage/:id/detail',
        loadComponent: () =>
            import('./features/occurrence-review/pages/occurrence-review-detail/occurrence-review-detail').then(
                (m) => m.OccurrenceReviewDetail,
            ),
        canActivate: [authGuard, permissionGuard],
        data: requires('read', 'Occurrence'),
    },
    {
        path: 'occurrences/awaitingtriage',
        loadComponent: () =>
            import('./features/occurrence-review/pages/occurrence-review-list/occurrence-review-list').then(
                (m) => m.OccurrenceReviewList,
            ),
        children: [
            {
                path: ':id',
                loadComponent: () =>
                    import('./features/occurrence-review/pages/occurrence-review-panel/occurrence-review-panel').then(
                        (m) => m.OccurrenceReviewPanel,
                    ),
            },
        ],
        canActivate: [authGuard, permissionGuard],
        data: requires('read', 'Occurrence'),
    },
    {
        path: 'occurrences/triagereview/:id/detail',
        loadComponent: () =>
            import('./features/occurrence-review/pages/occurrence-review-detail/occurrence-review-detail').then(
                (m) => m.OccurrenceReviewDetail,
            ),
        canActivate: [authGuard, permissionGuard],
        data: requires('read', 'Occurrence'),
    },
    {
        path: 'occurrences/triagereview',
        loadComponent: () =>
            import('./features/occurrence-review/pages/occurrence-reviewed-list/occurrence-reviewed-list').then(
                (m) => m.OccurrenceReviewedList,
            ),
        children: [
            {
                path: ':id',
                loadComponent: () =>
                    import('./features/occurrence-review/pages/occurrence-review-panel/occurrence-review-panel').then(
                        (m) => m.OccurrenceReviewPanel,
                    ),
            },
        ],
        canActivate: [authGuard, permissionGuard],
        data: requires('read', 'Occurrence'),
    },
    {
        path: 'irg/:id/detail',
        loadComponent: () =>
            import('./features/irg/pages/irg-detail/irg-detail').then((m) => m.IrgDetail),
        canActivate: [authGuard, permissionGuard],
        data: requires('read', 'IrgReview'),
    },
    {
        path: 'irg',
        loadComponent: () =>
            import('./features/irg/pages/irg-list/irg-list').then((m) => m.IrgList),
        children: [
            {
                path: ':id',
                loadComponent: () =>
                    import('./features/irg/pages/irg-panel/irg-panel').then((m) => m.IrgPanel),
            },
        ],
        canActivate: [authGuard, permissionGuard],
        data: requires('read', 'IrgReview'),
    },
    {
        path: 'officemanagement/myfavourites',
        loadComponent: () =>
            import('./features/my-favourite/pages/favourite-operators-list/favourite-operators-list').then(
                (m) => m.FavouriteOperatorsList,
            ),
        canActivate: [authGuard, permissionGuard],
        data: requires('manage', 'FavouriteOperator'),
    },
    {
        path: 'officemanagement/assignrsooffice',
        loadComponent: () =>
            import('./features/assign-rso-office/pages/assign-rso-office-list/assign-rso-office-list').then(
                (m) => m.AssignRsoOfficeList,
            ),
        canActivate: [authGuard, permissionGuard],
        data: requires('read', 'RsoOfficeAssignment'),
    },
    {
        path: 'admin/prioritisation',
        loadComponent: () =>
            import('./features/manage-prioritisation/pages/manage-prioritisation/manage-prioritisation').then(
                (m) => m.ManagePrioritisation,
            ),
        canActivate: [authGuard, permissionGuard],
        data: requires('manage', 'PrioritisationConfig'),
    },
    {
        path: 'admin/history',
        loadComponent: () =>
            import('./features/occurrence-history/pages/occurrence-history-list/occurrence-history-list').then(
                (m) => m.OccurrenceHistoryList,
            ),
        canActivate: [authGuard, permissionGuard],
        data: requires('read', 'OccurrenceHistory'),
    },
    {
        path: 'admin/access',
        loadComponent: () =>
            import('./features/access-control/pages/access-control/access-control').then((m) => m.AccessControl),
        canActivate: [authGuard, permissionGuard],
        data: requires('manage', 'AccessControl'),
    },
    {
        path: 'admin/session',
        loadComponent: () =>
            import('./features/session-expiry/pages/session-expiry/session-expiry').then((m) => m.SessionExpiry),
        canActivate: [authGuard, permissionGuard],
        data: requires('manage', 'Session'),
    },
    {
        path: 'login',
        loadComponent: () =>
            import('./core/auth/pages/login/login').then((m) => m.Login),
        canActivate: [loginGuard],
    },
];
